@if (showZoomControls && showZoomFlag) {
  <div class="zoom-controls m-r-24 p-10" [ngClass]="{ 'pinch-zoom-enabled': pinchZoomEnabled && isMobile }">
    <button
      type="button"
      title="Zoom In"
      id="btnZoomIn"
      class="zoom-button p-2"
      (mousedown)="startZoom(true)"
      (mouseup)="stopZoom()"
      (mouseleave)="stopZoom()"
      [disabled]="inDisabled"
      [ngClass]="{ active: zoomDirection.value === 'in', disabled: inDisabled }"
      data-test-id="zoom-in-button"
    >
      <mat-icon svgIcon="PLUS"></mat-icon>
    </button>
    @if (!autoZoomFlag) {
      <div class="controls-divider m-t-10 m-b-6"></div>
    }
    @if (autoZoomFlag) {
      <button
        type="button"
        (click)="toggleAutoZoom()"
        [matTooltip]="autoZoomTooltip()"
        [matTooltipPosition]="'right'"
        class="auto-zoom-button p-2"
        [ngClass]="{ enabled: autoZoomEnabled }"
        data-test-id="auto-zoom-button"
      >
        Auto
      </button>
    }
    <button
      type="button"
      title="Zoom Out"
      id="btnZoomOut"
      class="zoom-button p-2"
      (mousedown)="startZoom(false)"
      (mouseup)="stopZoom()"
      (mouseleave)="stopZoom()"
      [disabled]="outDisabled"
      [ngClass]="{ active: zoomDirection.value === 'out', disabled: outDisabled }"
      data-test-id="zoom-out-button"
    >
      <mat-icon svgIcon="MINUS"></mat-icon>
    </button>
  </div>
}
